module.exports = __webpack_public_path__ + "static/media/clean_weekly_2.5_hours.50ba78d5.svg";